<template>
  <div style="height: 100%">
    <el-container>
      <div class="header">

    <div class="logo-new">
      <div class="top_nav" style="position:absolute;right: 60px;top: 1px;">
          <ul>
            <li> <el-button  @click="submitForm()" type="primary">退出</el-button></li>
          </ul>
        </div>
        <h2>
            <a href="http://sme.miit.gov.cn/chengxin/"></a>
        </h2>
    </div><!--div class="release"><img src="/cms/resource/8a8900c96a48cf51016a4c70e1e80136//style/images/head_banner.gif" width="900" height="90"/></div-->
</div><div id="nav-bar">
    <div class="nav-bar">
      <!--  <ul class="nav">
         <router-link to='/' tag="li">首页</router-link>
            <li>
                <a href="http://sme.miit.gov.cn/cms/news/100000/0000000812/0000000812.shtml" target="_blank" title="信用动态" _href="/cms/news/100000/0000000812/0000000812.shtml" textvalue="信用动态">信用动态</a>
            </li>
            <li>
                <a href="http://sme.miit.gov.cn/cms/news/100003/index.shtml" target="_blank" title="政策法规" _href="/cms/news/100003/index.shtml" textvalue="政策法规">政策法规</a>
            </li>
          <router-link to='/creditsearch' tag="li"><a>信用公示</a></router-link>
            <li>
                <a href="http://sme.miit.gov.cn/cms/show.action?code=publish_8a8380b9645fe4f50164abf41fa73b3a&amp;siteid=100000&amp;newsid=ddfea0dd038e4dc9b17c6fd787b6cc18&amp;channelid=0000000814" title="信用服务" target="_blank">信用服务</a>
            </li>
            <li>
                <a href="http://sme.miit.gov.cn/cms/news/100000/0000000815/0000000815.shtml" target="_blank" title="诚信访谈" _href="/cms/news/100000/0000000815/0000000815.shtml" textvalue="诚信访谈">诚信访谈</a>
            </li>
        </ul>-->
        <div class="clearfix"></div>
    </div>
</div>
      <el-container >
  <el-container>
    <el-aside width="190px">
      <el-col >
    <el-menu  class="el-menu-vertical-demo" >
      <el-menu-item index="1">
        <i class="el-icon-menu"></i>
        <span slot="title"> <router-link to='/modifymessage' >企业信息 </router-link></span>
      </el-menu-item>

      <el-menu-item index="2">
        <i class="el-icon-menu"></i>
        <span slot="title"> <router-link to='/enterevaluation' >评价申请</router-link></span>
      </el-menu-item>

       <el-menu-item index="3">
        <i class="el-icon-menu"></i>
        <span slot="title"><router-link to='/enterquerylists' >结果查询</router-link></span>
      </el-menu-item>
    </el-menu>
  </el-col>

    </el-aside>
    <el-main> <router-view></router-view></el-main>
  </el-container>
</el-container>

      <el-footer><!--版权开始-->
<div class="tab_c6">
    <div class="tab_c6_lx" style="background-color: #fff;">
        <a title="关于我们" href="/cms/news/100000/0000000347/2016/1/22/97d5dd83bbba4ffb8f30aaa1c746e1d3.shtml" target="_blank" _href="/cms/news/100000/0000000347/2016/1/22/97d5dd83bbba4ffb8f30aaa1c746e1d3.shtml" textvalue="关于我们">关于我们</a>  |   <a title="联系我们" href="/cms/news/100000/0000000348/2016/1/22/e419856644c44d9091519e246f8cb742.shtml" target="_blank" _href="/cms/news/100000/0000000348/2016/1/22/e419856644c44d9091519e246f8cb742.shtml">联系我们</a>  |   <a title="本网招聘" href="/cms/news/100000/0000000350/2016/10/27/9fe8ee98fec64568bfde4bbb40b6bfb9.shtml" target="_blank" _href="/cms/news/100000/0000000350/2016/10/27/9fe8ee98fec64568bfde4bbb40b6bfb9.shtml">本网招聘</a>  |   <a title="友情链接" href="/cms/news/100000/0000000351/2016/1/25/0d6a8c7882cc4fee83e1baa064384dc1.shtml" target="_blank" _href="/cms/news/100000/0000000351/2016/1/25/0d6a8c7882cc4fee83e1baa064384dc1.shtml">友情链接</a>
    </div>
    <div class="tab_c6_foot">
        <div>
            <div class="zddw">
                    指导单位：中华人民共和国工业和信息化部
            </div>
            <div class="jz">
                <td class="lxfs">
                    联系方式：010-68575152 13810303299
                </td>
                <td class="lxfs">
                    京ICP备12018716号
                </td>
                <td class="lxfs">
                    京公网案备 110102001365
                </td>
            </div>
        </div>
    </div>
</div><!--版权结束--><br/> </el-footer>
    </el-container>
  </div>
</template>

<script>
import rootPathssb from '@/api/mainApi'
import { dataGetUrl } from '@/api/index'
export default {
  name: 'enterpriselist',
  created () {
    var that = this
    /* 获取父页面参数 */

    /* 后台申请默认值 */
    dataGetUrl(rootPathssb.rootPath + '/user/find').then(function (response) {
      that.checkSignin(response.data.result)
      console.log(response.data)
      if (response.data.result === 1) {
        console.log('cg')
        that.form1 = response.data.object
      };

      console.log(response.data)
    }).catch(function (error) {
      console.log(error); console.log('aaa')
    })
  },
  methods: {
    submitForm (event) {
      localStorage.setItem('State-Check', '2')
      dataGetUrl(rootPathssb.rootPath + '/user/signout').then(function (response) {
        console.log(response)
        if (rootPathssb.sso) {
          if (response.data.result === 1) {
            localStorage.removeItem('User-Auth')
            window.location.href = response.data.msg
          }
          // localStorage.setItem('User-Auth', null)
          //  window.location.href = '/'
        } else {
          if (response.data.result === 1) {
            alert('退出')
            window.location.href = '/enterpriselogin'
            localStorage.setItem('User-Auth', null)
            console.log('cg')
          };
        }

        console.log(response.data)
      }).catch(function (error) {
        console.log(error); console.log(2222222222)
      })
    }

  }
}
</script>

<style scoped>
  a {text-decoration:none;
    color: #333333;
  }
 .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
  }

  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }

  .el-main {
    background-color: #f5f5f5;
    color: #333;
    width: 100%;
    margin: 0 auto;
    overflow-y: hidden;
    overflow-x: hidden;
  }

  body > .el-container {
    margin-bottom: 40px;
  }

  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }

  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
  .header {
    margin: 10px auto;
    width: 1200px;
    height: 153px;
}
  .header .logo-new {
    width: 1200px;
    height: 153px;
    background: url(../../assets/img/logo-new.jpg) no-repeat;
}
  #nav-bar {
    background: #0081d3;}
  .nav-bar {
    margin: 10px auto 10px;
    width: 1200px;
}
  .nav-bar ul {
    height: 35px;
    font-size: 18px;
    color: #fff;
    list-style-type: none;
    width: 1000px;
    margin: auto;
}
   .top_nav a{
      text-decoration:none;
   }
  .top_nav ul li{
     list-style-type: none;

  }
 .nav-bar ul li {
    display: inline-block;
    float: left;
    padding: 0 40px;
    line-height: 35px;
    font-size: 18px;
    text-align: center;
   list-style-type: none;
}
  .nav-bar a {
    color: #fff;
    text-decoration: none;
}
  .tab_c6 {
    width: 1200px;
    height: 120px;
    margin: 10px auto 0;
    text-align: center;
}
  .tab_c6_lx {
    background-color: #ddd;
    font-size: 14px;
    color: #000;
    line-height: 35px;
}

.tab_c6_lx  a {
    color: #000;
    text-decoration: none;
}
  .tab_c6_foot {
    font-size: 12px;
    color: #888;
    line-height: 28px;
}
  .tab_c6_foot ul {
    float: left;
    width: 930px;
    margin-left: 200px;
    list-style: none;
}
  .tab_c6_foot li {
    width: 930px;
    text-align: center;
    float: left;
    color: #333;
    font-size: 14px;
    line-height: 28px;
}
  .tab_c6_foot li h4 {
    margin-right: 20px;
    text-align: center;
    float: left;
    line-height: 28px;
    font-weight: normal;
}
 .zddw{
   margin-top: 20px;
 }
  .lxfs{
    margin-right: 50px;
    width: 200px;
  }
  .jz{
        width: 600px;
    margin: auto;
  }
 .bg-purple {
    background: #337ab7;
  }
  .bg-purple-light {
    background: #1E88E5;
  }
  .grid-content {
  }

  .el-aside {
    background-color: #ffffff;
    color: #333;
    text-align: center;
    min-height: 600px;
  }

  .el-main {
    background-color: #E9EEF3;
    color: #333;
    min-height: 600px;
  }

</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriselist.vue